module.exports = __webpack_public_path__ + "img/25.3c4f93bf.png";